module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<span class="inventory-tags-label">\n    Inventory ID:&nbsp;\n</span>\n';
 if (editable) { ;
__p += '\n    <div class="inventory-tag-input-container">\n        <form class="inventory-tag-new-form">\n            <div class="inventory-form-group">\n                <input type="text" class="inventory-tag-input" placeholder="New inventory ID" maxlength="' +
__e( maxNameLength ) +
'" />\n                <span class="inventory-tag-input-message"></span>\n            </div>\n        </form>\n    </div>\n';
 } ;
__p += '\n<ul class="inventory-tags-list"></ul>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/assets/image/inventory/InventoryTagCompositeView.tpl
// module id = 1735
// module chunks = 0